import { useEffect, useRef } from "react"
import * as THREE from "three"
import { useThree } from "@react-three/fiber"
import useGame from "./stores/useGame.js"

export default function MusicScene({ active }) {
  const { camera } = useThree()
  const startBgMusic = useGame((state) => state.startBgMusic)
  const space = useGame((state) => state.space)
  const soundRef = useRef(null)
  const listenerRef = useRef(null)

  // Setup listener once
  useEffect(() => {
    if (!active) return

    const listener = new THREE.AudioListener()
    listenerRef.current = listener
    camera.add(listener)

    const sound = new THREE.Audio(listener)
    soundRef.current = sound

    return () => {
      if (soundRef.current?.isPlaying) soundRef.current.pause()
      soundRef.current = null
      camera.remove(listener)
    }
  }, [camera, active])

  // Load a new buffer only when space changes
  useEffect(() => {
    if (!active || !listenerRef.current || !soundRef.current) return

    let url, volume
    if (space === "alley") {
      url = "/Music/alley2.mp3"
      volume = 0.04
    } else if (space === "stage") {
      url = "/Music/stage2.mp3"
      volume = 0.05
    }

    if (!url) return

    const loader = new THREE.AudioLoader()
    loader.load(url, (buffer) => {
      const sound = soundRef.current
      if (!sound) return

      // Stop previous before swapping buffer
      if (sound.isPlaying) sound.stop()

      sound.setBuffer(buffer)
      sound.setLoop(true)
      sound.setVolume(volume)

      if (startBgMusic) sound.play()
    })
  }, [space, active, startBgMusic])

  // Handle mute/unmute without reloading buffer
  useEffect(() => {
    if (!active || !soundRef.current) return
    const sound = soundRef.current

    if (startBgMusic) {
      if (!sound.isPlaying) sound.play()
    } else {
      if (sound.isPlaying) sound.pause()
    }
  }, [startBgMusic, active])

  return null
}
